module.exports = __webpack_public_path__ + "static/media/impreza-pcd.a3f6c066.png";